import { DestroyRef, Directive, ElementRef, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { onResize } from '@coin/shared/core/util-helpers';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

/** Enables or disables matTooltip if the attached element has ellipsis overflow and sets the content to the text content.
 * @example `<p class="overflow-ellipsis" coinEllipsisTooltip matTooltip> Hello World! </p>`
 * */
@Directive({
  selector: '[coinEllipsisTooltip][matTooltip]',
  standalone: true
})
export class EllipsisTooltipDirective {
  private readonly matTooltip = inject(MatTooltip);
  private readonly elem = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.syncTooltipWithEllipsis();
  }

  private syncTooltipWithEllipsis(): void {
    onResize(this.elem.nativeElement)
      .pipe(
        map(() => isEllipsisActive(this.elem.nativeElement)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(isEllipsed => {
        this.matTooltip.disabled = !isEllipsed;
        this.matTooltip.message = this.elem.nativeElement.textContent;
      });
  }
}

function isEllipsisActive(element: HTMLElement): boolean {
  return element.offsetWidth < element.scrollWidth || element.offsetHeight < element.scrollHeight;
}
